import { render, staticRenderFns } from "./DdNumericBox.vue?vue&type=template&id=2244bed8&"
import script from "./DdNumericBox.vue?vue&type=script&lang=js&"
export * from "./DdNumericBox.vue?vue&type=script&lang=js&"
import style0 from "./DdNumericBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTextField,VTooltip})
